import {ACCOUNTS_INSTANCE, RECORDING_INSTANCE} from "@/helper/consts";
import Base from "@/modules/recording/page/Base"
import names from '@/modules/recording/routers/names'
import adminRecording from '@/modules/recording/routers/adminRecording'
import core from '@/modules/core/routers'
import publicRecording from '@/modules/recording/routers/publicRecording'
import adminEvents from '@/modules/recording/routers/adminEvents'

export default ([
    {
        path: '',
        name: names.BASE,
        component: Base,
        meta: {
            breadcrumb: 'Мероприятия',
            instances: [
                RECORDING_INSTANCE,
                ACCOUNTS_INSTANCE
            ]
        },
        children: [
            ...publicRecording,
            ...adminRecording,
            ...adminEvents
        ]
    },
    ...core,

])


